import React from 'react';

const PayrollStats = ({ payrolls }) => {
    return (
        <div className="row mt-4">
            <div className="col-12">
                <div className="card bg-light border-0">
                    <div className="card-body py-3">
                        <div className="row text-center">
                            <div className="col-md-3">
                                <div className="fw-bold text-primary fs-4">{payrolls.length}</div>
                                <small className="text-muted">Total Periods</small>
                            </div>
                            <div className="col-md-3">
                                <div className="fw-bold text-warning fs-4">
                                    {payrolls.filter(p => p.status === 'Open').length}
                                </div>
                                <small className="text-muted">Open Periods</small>
                            </div>
                            <div className="col-md-3">
                                <div className="fw-bold text-success fs-4">
                                    {payrolls.filter(p => p.status === 'Processed').length}
                                </div>
                                <small className="text-muted">Processed</small>
                            </div>
                            <div className="col-md-3">
                                <div className="fw-bold text-danger fs-4">
                                    {payrolls.filter(p => p.status === 'Closed').length}
                                </div>
                                <small className="text-muted">Closed</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PayrollStats;